if (!customElements.get('c-cookie-consent')) {
  customElements.define(
    'c-cookie-consent',
    class CookieConsent extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
      }

      connectedCallback() {
        this.banner = this.querySelector('.c_c-footer-cookie-banner');
        this.dialog = this.querySelector('.c_c-footer-cookie-banner__dialog');
        this.addEventListener('click', this.onClick);
        // Cookie ポリシーのページの設定ボタンはこの要素の外にあるため、document で受ける
        document.addEventListener('click', this.onDocumentClick);

        window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (!error) this.setup();
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('click', this.onDocumentClick);
      }

      setup() {
        this.syncCheckboxes();
        // Liquid で disabled にしてあるボタンを、記録・表示できるようになった時点で有効にする
        document.querySelectorAll('[data-cookie-action], .c_js-cookie-settings-open').forEach((button) => {
          button.disabled = false;
        });
        if (window.Shopify.customerPrivacy.shouldShowBanner() || window.Shopify.designMode) {
          this.banner.hidden = false;
        }
      }

      syncCheckboxes() {
        const privacy = window.Shopify.customerPrivacy;
        const consent = privacy.currentVisitorConsent();
        // 未選択（''）のときは地域の既定で許可されているかを表示する。オフで出すと、そのまま保存して全部拒否になる
        const allowed = {
          preferences: privacy.preferencesProcessingAllowed(),
          analytics: privacy.analyticsProcessingAllowed(),
          marketing: privacy.marketingAllowed(),
        };
        this.dialog.querySelectorAll('[data-consent]').forEach((input) => {
          const value = consent[input.dataset.consent];
          input.checked = value === 'yes' || (value !== 'no' && allowed[input.dataset.consent]);
        });
      }

      onClick(event) {
        if (event.target.closest('.c_js-cookie-settings-close')) {
          this.dialog.close();
          return;
        }
        if (event.target === this.dialog) {
          this.dialog.close();
          return;
        }
        const action = event.target.closest('[data-cookie-action]')?.dataset.cookieAction;
        if (!action || !window.Shopify?.customerPrivacy) return;

        const consent = {};
        this.dialog.querySelectorAll('[data-consent]').forEach((input) => {
          consent[input.dataset.consent] = action === 'save' ? input.checked : action === 'accept';
        });
        // データの販売・共有は設定の項目に出さず、マーケティングと同じ選択として記録する
        consent.sale_of_data = consent.marketing;
        this.saveConsent(consent);
      }

      onDocumentClick(event) {
        if (!event.target.closest('.c_js-cookie-settings-open') || !window.Shopify?.customerPrivacy) return;
        this.syncCheckboxes();
        this.dialog.showModal();
      }

      saveConsent(consent) {
        // テーマエディタでは見た目の確認だけにし、編集者の同意を記録しない
        if (window.Shopify.designMode) {
          if (this.dialog.open) this.dialog.close();
          return;
        }
        window.Shopify.customerPrivacy.setTrackingConsent(consent, (response) => {
          if (response?.error) return;
          if (this.dialog.open) this.dialog.close();
          if (!this.banner.hidden) {
            // 押したボタンごとバナーを隠すとフォーカスが失われるため、main へ移す
            const hadFocus = this.banner.contains(document.activeElement);
            this.banner.hidden = true;
            if (hadFocus) document.getElementById('MainContent')?.focus({ preventScroll: true });
          }
          this.syncCheckboxes();
        });
      }
    }
  );
}
